
export const useCase = {
  title: "Who is it for?",
  description: "Discover how different creators can use the platform",
  addButton: "Add Use Case",
  name: "Title",
  description_field: "Description",
  icon: "Icon",
  image: "Image",
  actions: "Actions",
  edit: "Edit",
  delete: "Delete",
  success: {
    create: "Use case created successfully",
    update: "Use case updated successfully",
    delete: "Use case deleted successfully"
  },
  errors: {
    create: "Failed to create use case",
    update: "Failed to update use case",
    delete: "Failed to delete use case"
  }
};
